// deps
import React, { memo, ReactElement, useState, useCallback, useRef } from "react";

// internal-deps
import { RenderingDetails } from "@swiggy-private/cart-types";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// components
import { Tooltip } from "../../../tooltip";

// styles
import styles from "../../../BillDetailItem.scss";

interface NameProps {
    itemData: RenderingDetails;
    onClickInfoIcon?: (key: string) => void;
    canShowTooltip?: (itemData: RenderingDetails) => boolean;
}

const Name = ({ itemData, onClickInfoIcon, canShowTooltip }: NameProps): ReactElement => {
    const [showTooltip, setShow] = useState(false);
    const triggerRef = useRef(null);
    const [position, setPosition] = useState({
        x: 0,
        y: 0,
    });

    const handleClick = useCallback(
        (event) => {
            if (!showTooltip && event.target) {
                typeof onClickInfoIcon === "function" && onClickInfoIcon(itemData.key);
                const { x, y, width } = event.target.getBoundingClientRect();
                setPosition({ x: x + width / 2, y });
                setShow(true);
            }
        },
        [showTooltip, onClickInfoIcon, itemData],
    );
    return (
        <>
            {canShowTooltip?.(itemData) ? (
                <>
                    <div
                        className={styles.tooltipTrigger}
                        onClick={handleClick}
                        ref={triggerRef}
                        data-testid={`${itemData.key}_ITEM_NAME`}
                    >
                        {itemData.display_text}
                    </div>

                    {showTooltip && (
                        <Tooltip
                            position={position}
                            widgetSize={"170"}
                            triggerRef={triggerRef}
                            hide={(): void => setShow(false)}
                        >
                            <div>{itemData.info_text}</div>
                        </Tooltip>
                    )}
                </>
            ) : (
                <div data-testid={`${itemData.key}_ITEM_NAME`}>
                    {itemData?.meta?.logoId && (
                        <>
                            <Image
                                className={styles.displayTextLogo}
                                cloudinaryId={itemData.meta.logoId}
                                width="15px"
                                fit="contain"
                            />{" "}
                        </>
                    )}
                    {itemData.display_text}
                </div>
            )}
        </>
    );
};

export default memo(Name);
